export class StorageManager {
  public static TTL = 86400

  public load<T = unknown>(key: string): T | string | null {
    const body = sessionStorage.getItem(key)
    if (body) {
      try {
        const jsonBody = JSON.parse(body)
        if (jsonBody) {
          if (new Date().getTime() < jsonBody.timestamp) {
            return jsonBody.value as T
          } else {
            return null
          }
        } else {
          return null
        }
      } catch (err) {
        // If JSON parsing fails, return the raw string
        return body
      }
    }
    return null
  }

  public save<T = unknown>(key: string, data: T, ttl: number = StorageManager.TTL): void {
    const dataRecord = JSON.stringify({
      value: data,
      timestamp: new Date().getTime() + ttl * 1000,
    })
    sessionStorage.setItem(key, dataRecord)
  }

  public remove(key: string): void {
    return sessionStorage.removeItem(key)
  }

  public clear(): void {
    return sessionStorage.clear()
  }
}
